<template>
  <div class="">
    <card id="ler_step4_extrInfo" tabindex="0" class="mt-15">
      <div slot="header">
        <h3 class="card-title">부가 정보</h3>
      </div>
      <div class="row m-row">
        <!-- 옵션 -->
        <div class="fl col-lg-6 px-0 mb-10 jipvio-bg-white">
          <label class="fl col-3 col-form-label px-0">옵션</label>
          <div class="fl col-9 pl-0">
            <ValidationProvider
              vid="optionYnVal"
              rules="required"
              v-slot="{ failed }"
              class="fl mr-10"
            >
              <fg-input :error="failed ? '필수 입력 항목입니다!' : null">
                <el-radio-group v-model="optionYn">
                  <el-radio
                    class="ml-0 mr-0"
                    ref="optionYnButtonRef"
                    label="1"
                    border
                    >있음</el-radio
                  >
                  <el-radio
                    class="m-ml-0"
                    label="0"
                    border
                    @change="optionList = []"
                    >없음</el-radio
                  >
                </el-radio-group>
              </fg-input>
            </ValidationProvider>

            <div v-if="Number(optionYn) === 1">
              <ValidationProvider
                vid="optionListSelectVal"
                rules="required"
                v-slot="{ failed }"
                class="fl px-0 col-md-7"
              >
                <fg-input :error="failed ? '필수 입력 항목입니다!' : null">
                  <el-select
                    v-model="optionList"
                    multiple
                    placeholder="옵션"
                    class="fl ft-18"
                  >
                    <el-option
                      v-for="opt in selects.BIO"
                      :key="opt.value"
                      :label="opt.label"
                      :value="opt.value"
                    ></el-option>
                  </el-select>
                </fg-input>
              </ValidationProvider>
            </div>
          </div>
        </div>

        <!--보안시설 -->
        <div class="fl col-lg-6 px-0 mb-10 jipvio-bg-white">
          <label class="fl col-3 col-form-label px-0">보안시설</label>
          <div class="fl col-9 pl-0">
            <ValidationProvider
              vid="securityYnVal"
              rules="required"
              v-slot="{ failed }"
              class="fl mr-10"
            >
              <fg-input :error="failed ? '필수 입력 항목입니다!' : null">
                <el-radio-group v-model="securityYn">
                  <el-radio class="mr-0" label="1" border>있음</el-radio>
                  <el-radio
                    class="m-ml-0"
                    label="0"
                    border
                    @change="securityList = []"
                    >없음</el-radio
                  >
                </el-radio-group>
              </fg-input>
            </ValidationProvider>

            <div v-if="Number(securityYn) === 1">
              <ValidationProvider
                vid="securityListSelectVal"
                rules="required"
                v-slot="{ failed }"
                class="fl px-0 col-md-7"
              >
                <fg-input :error="failed ? '필수 입력 항목입니다!' : null">
                  <el-select
                    v-show="Number(securityYn) === 1"
                    v-model="securityList"
                    placeholder="보안시설"
                    multiple
                    class="fl ft-18"
                  >
                    <el-option
                      v-for="opt in selects.SCF"
                      :key="opt.value"
                      :label="opt.label"
                      :value="opt.value"
                    ></el-option>
                  </el-select>
                </fg-input>
              </ValidationProvider>
            </div>
          </div>
        </div>

        <!--반려동물-->
        <div class="fl col-lg-6 px-0 mb-10">
          <label class="fl col-3 col-form-label px-0">반려동물</label>
          <div class="fl col-9 pl-0">
            <ValidationProvider
              vid="petYnVal"
              rules="required"
              v-slot="{ failed }"
            >
              <fg-input :error="failed ? '필수 입력 항목입니다!' : null">
                <el-radio-group v-model="petYn">
                  <el-radio class="mr-0" label="1" border>가능</el-radio>
                  <el-radio class="m-ml-0" ref="petYnButtonRef" label="0" border
                    >불가능
                  </el-radio>
                </el-radio-group>
              </fg-input>
            </ValidationProvider>
          </div>
        </div>

        <!-- 방문 가능 요일 -->
        <div class="fl col-lg-6 px-0 mb-10">
          <label class="fl col-3 col-form-label pl-0">방문 가능 요일</label>
          <div class="fl col-9 pl-0 jipvio-bg-white">
            <ValidationProvider
              vid="possibleVisitDaysVal"
              rules="required"
              v-slot="{ failed }"
            >
              <fg-input :error="failed ? '필수 입력 항목입니다!' : null">
                <el-select
                  ref="PVDSelectRef"
                  v-model="possibleVisitDays"
                  multiple
                  placeholder="방문 가능 요일"
                >
                  <el-option
                    v-for="opt in selects.VPD"
                    :key="opt.value"
                    :label="opt.label"
                    :value="opt.value"
                  ></el-option>
                </el-select>
              </fg-input>
            </ValidationProvider>
          </div>
        </div>

        <!--방문 가능 시간 -->
        <div class="fl col-lg-6 px-0 mb-10">
          <label class="fl col-3 col-form-label pl-0 ">방문 가능 시간</label>

          <div class="fl col-9 pl-0 jipvio-bg-white">
            <ValidationProvider
              vid="possibleVisitTimesVal"
              rules="required"
              v-slot="{ failed }"
            >
              <fg-input :error="failed ? '필수 입력 항목입니다!' : null">
                <el-select
                  ref="PVTSelectRef"
                  v-model="possibleVisitTimes"
                  multiple
                  placeholder="방문 가능 시간"
                >
                  <el-option
                    v-for="opt in selects.VPT"
                    :key="opt.value"
                    :label="opt.label"
                    :value="opt.value"
                  ></el-option>
                </el-select>
              </fg-input>
            </ValidationProvider>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapGetters } from "vuex";
const { mapGetters: sessionMapGetters } = createNamespacedHelpers(
  "loginSession"
);

import {
  Card,
  Input,
  Select,
  Option,
  RadioGroup,
  Radio,
  Message
} from "element-ui";

export default {
  components: {
    Card,
    [Input.name]: Input,
    [Select.name]: Select,
    [Option.name]: Option,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup
  },

  data() {
    return {
      optionYn: null, //옵션유무
      optionList: [], //선택된 옵션들
      securityYn: null,
      securityList: [], //선택된 보안시설
      petYn: null, //반려동물 가능여부
      possibleVisitDays: [], //방문 가능 요일
      possibleVisitTimes: [], //방문 가능 시간

      selects: {
        BIO: [],
        VPD: [],
        VPT: [],
        SCF: []
      }
    };
  },

  created() {
    this.bringdata();
    this.applyCommonCode();
  },

  computed: {
    ...sessionMapGetters({
      sessionCoCodeMap: "getCoCodeMap",
      sessionPropertyInquiry: "getPropertyInquiry"
    })
  },

  methods: {
    bringdata() {
      this.optionYn = Number(
        this.sessionPropertyInquiry.propertyInfo.optionYn
      ).toString(); //옵션유무
      this.optionList = this.sessionPropertyInquiry.propertyInfo.optionList; //선택된 옵션들
      this.securityYn = Number(
        this.sessionPropertyInquiry.propertyInfo.securityYn
      ).toString();
      this.securityList = this.sessionPropertyInquiry.propertyInfo.securityList; //선택된 보안시설
      this.petYn = Number(
        this.sessionPropertyInquiry.propertyInfo.petYn
      ).toString(); //반려동물 가능여부
      this.possibleVisitDays = this.sessionPropertyInquiry.propertyInfo.possibleVisitDays; //방문 가능 요일
      this.possibleVisitTimes = this.sessionPropertyInquiry.propertyInfo.possibleVisitTimes; //방문 가능 시간
    },

    applyCommonCode() {
      //BIO========================================================
      this.sessionCoCodeMap.BIO.forEach((ele, dex) => {
        this.selects.BIO.push({
          value: ele.code,
          label: ele.name
        });
      });

      //VPD======================================================== //
      this.sessionCoCodeMap.VPD.forEach((ele, dex) => {
        this.selects.VPD.push({
          value: ele.code,
          label: ele.name
        });
      });

      //VPT========================================================  //
      this.sessionCoCodeMap.VPT.forEach((ele, dex) => {
        this.selects.VPT.push({
          value: ele.code,
          label: ele.name
        });
      });

      //SCF========================================================  //
      this.sessionCoCodeMap.SCF.forEach((ele, dex) => {
        this.selects.SCF.push({
          value: ele.code,
          label: ele.name
        });
      });
    },

    SendExtraData() {
      let data = {
        optionYn: this.optionYn,
        optionList: this.optionList,
        securityYn: this.securityYn,
        securityList: this.securityList,
        petYn: this.petYn,
        possibleVisitDays: this.possibleVisitDays,
        possibleVisitTimes: this.possibleVisitTimes
      };
      this.$emit("SendExtraData", data);
    }
  }
};
</script>

<style></style>
